import {type WBSlateElementType} from '../../components/Slate/WBSlate/types';
import {type LinePlotSettings} from '../../components/WorkspaceDrawer/Settings/types';
import {type DiscussionThread} from '../../state/views/discussionThread/types';
import {type Config as MarkdownBlockConfig} from '../../state/views/markdownBlock/types';
import {type ReportWidthOption} from '../../state/views/report/types';
import {type Config as SectionConfig, type ReportAuthor} from '../section';
import {type ReportSpecVersion} from './shared';

export {ReportSpecVersion} from './shared';

// Invariants (not managed by TypeScript):
//   - if we have a Global section, each PanelGroup section has the
//     exactly the same number of RunSets as the Global section has.

type Block = SectionConfig | MarkdownBlockConfig;

export interface ReportConfig {
  global: SectionConfig;
  width: ReportWidthOption;
  // TODO(john): panelGroups is no longer just panel groups. Rename to blocks.
  // But be careful because it's referenced in many places, some not typed.
  panelGroups: Block[];
  // if panelbank has not been turned on + initialized, version will be ReportSpecVersion.V0
  // if panelbank been turned on + initialized, version will be ReportSpecVersion.Panelbank
  version: ReportSpecVersion;
  authors?: ReportAuthor[];
  // dicussionThreads is populated by ReportActions.loadDiscussionThreads
  discussionThreads: DiscussionThread[];
}

export interface SlateReport {
  version: ReportSpecVersion;
  authors?: ReportAuthor[];
  discussionThreads: DiscussionThread[];
  width: ReportWidthOption;
  panelSettings: LinePlotSettings;
  blocks: WBSlateElementType[];
}
